import React, { useEffect, useState } from "react";
import styles from "./SoftwarePage.module.css";

export default function SoftwarePage() {
  const [devices, setDevices] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");

  useEffect(() => {
    fetch("/data/software.json")
      .then((res) => res.json())
      .then((data) => setDevices(data))
      .catch((err) => console.error("Failed to load software data:", err));
  }, []);

  const filteredDevices = devices.filter((device) =>
    device.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
    device.company.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className={styles.container}>
      <h1 className={styles.title}>Software</h1>

      {devices.length === 0 ? (
        <p className={styles.loading}>Loading data...</p>
      ) : (
        <>
          <div className={styles.searchSection}>
            <input
              type="text"
              placeholder="Search device or company..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className={styles.searchInput}
            />
            {searchTerm && (
              <button
                onClick={() => setSearchTerm("")}
                className={styles.clearButton}
                aria-label="Clear"
              >
                ×
              </button>
            )}
          </div>

          <div className={styles.grid}>
            {filteredDevices.length > 0 ? (
              filteredDevices.map((device) => (
                <div key={device.id} className={styles.deviceCard}>
                  <div className={styles.deviceHeader}>
                    <img
                      src={device.image}
                      alt={device.name}
                      className={styles.deviceIcon}
                      loading="lazy"
                    />
                    <div className={styles.deviceInfo}>
                      <div className={styles.companyName}>{device.company}</div>
                      <div className={styles.deviceName}>{device.name}</div>
                    </div>
                  </div>

                  {device.updates && device.updates.length > 0 && (
                    <div className={styles.updatesList}>
                      {device.updates.map((update, idx) => (
                        <div key={idx} className={styles.updateItem}>
                          <div
                            className={styles.updateMeta}
                            onClick={() => window.open(update.downloadUrl, "_blank")}
                            style={{ cursor: "pointer" }}
                            title="Click to download"
                          >
                            <span>
                              Server: <strong>{update.serverVersion}</strong>
                            </span>
                            <span>
                              Release date: <strong>{update.releaseDate}</strong>
                            </span>
                            <span>
                              Version: <strong>{update.versionNumber}</strong>
                            </span>
                          </div>

                          {update.downloadLinks && update.downloadLinks.length > 0 && (
                            <div className={styles.downloadLinks}>
                              {update.downloadLinks.map((link, i) => (
                                <a
                                  key={i}
                                  href={link.url}
                                  className={styles.downloadButton}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  onClick={(e) => e.stopPropagation()}
                                  download
                                >
                                  <i className="fas fa-download"></i> {link.text || "download"}
                                </a>
                              ))}
                            </div>
                          )}
                        </div>
                      ))}
                    </div>
                  )}

                  {device.supportLinks && device.supportLinks.length > 0 && (
                    <div className={styles.supportLinks}>
                      {device.supportLinks.map((link, idx) => (
                        <a
                          key={idx}
                          href={link.url}
                          className={styles.supportLink}
                          target="_blank"
                          rel="noopener noreferrer"
                          title="Support Link"
                          onClick={(e) => e.stopPropagation()}
                        >
                          <i className={link.type}></i>
                        </a>
                      ))}
                    </div>
                  )}
                </div>
              ))
            ) : (
              <p className={styles.loading}>No results found.</p>
            )}
          </div>
        </>
      )}
    </div>
  );
}
